import React from 'react';
import { typography } from '../../styles/typography';

/**
 * Banner shown when shift start/end times cross midnight (night / overnight shift).
 */
const OvernightShiftNotice = ({
  overnightShiftInfo,
  title = 'Night Shift',
  datePickerMode,
}) => {
  if (!overnightShiftInfo?.isOvernight) {
    return null;
  }

  return (
    <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <div className="flex items-center">
        <svg
          className="w-10 h-10 text-blue-600 mr-2 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
        <div className="text-blue-800">
          <p className={`${typography.sh2} font-semibold`}>{title}</p>
          <p className={`${typography.p} mt-1`}>
            From {overnightShiftInfo.startTimeFormatted} to{' '}
            {overnightShiftInfo.endTimeFormatted} is considered as overnight shift
          </p>
          {datePickerMode === 'range' && (
            <p className={`${typography.p} mt-1 font-medium`}>
              This shift will span across multiple days in the selected date range
            </p>
          )}
          {datePickerMode === 'multiple' && (
            <p className={`${typography.p} mt-1 font-medium`}>
              This shift will apply to all selected cleaning dates
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export const ShiftTimeValidationNotice = ({ overnightShiftInfo }) => {
  if (overnightShiftInfo?.isValid !== false || !overnightShiftInfo?.error) {
    return null;
  }

  return (
    <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
      <div className="flex items-center">
        <svg
          className="w-5 h-5 text-red-600 mr-2 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div className="text-red-800">
          <p className="font-medium text-sm">Invalid Time Range</p>
          <p className="text-xs mt-1">{overnightShiftInfo.error}</p>
        </div>
      </div>
    </div>
  );
};

export default OvernightShiftNotice;
